import React from "react";
import semanticVariables from "ui-v2/styles/semantic_colors.module.scss";

export default ({ width = 24, height = 24, color = "primary" }) => {
  const colorValue = semanticVariables?.[`semantic_icon_${color}`];
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 2.25C9.60649 2.24927 7.21613 2.4234 4.848 2.771C2.87 3.061 1.5 4.795 1.5 6.741V12.759C1.5 14.705 2.87 16.439 4.848 16.729C6.00172 16.8984 7.16113 17.0265 8.324 17.113C8.38317 17.1169 8.44068 17.1342 8.49214 17.1637C8.54361 17.1931 8.58768 17.234 8.621 17.283L11.376 21.416C11.4445 21.5187 11.5373 21.6029 11.6461 21.6612C11.755 21.7194 11.8765 21.7499 12 21.7499C12.1235 21.7499 12.245 21.7194 12.3539 21.6612C12.4627 21.6029 12.5555 21.5187 12.624 21.416L15.379 17.283C15.4123 17.234 15.4564 17.1931 15.5079 17.1637C15.5593 17.1342 15.6168 17.1169 15.676 17.113C16.8389 17.0268 17.9983 16.8991 19.152 16.73C21.13 16.438 22.5 14.706 22.5 12.76V6.74C22.5 4.794 21.13 3.062 19.152 2.77C16.817 2.428 14.43 2.25 12 2.25ZM13.8143 7C14.9036 7 15.7868 7.84783 15.7868 8.89341C15.7868 11.9313 12 13.9425 12 13.9425C12 13.9425 8.21313 11.9313 8.21313 8.89341C8.21313 7.84783 9.09673 7 10.1852 7C10.9998 7 11.6991 7.47377 12 8.14993C12.3008 7.47377 13.0001 7 13.8143 7Z"
        fill={colorValue}
      />
    </svg>
  );
};
